import { Module } from '@nestjs/common';
import { MandalController } from './mandal.controller';
import { MandalService } from './mandal.service';
import {MandalEntity} from './mandal.entity';
import { TypeOrmModule} from '@nestjs/typeorm';

@Module({
  imports :[
    TypeOrmModule.forFeature([MandalEntity]),
  ],
  exports: [MandalService],
  controllers: [MandalController],
  providers: [MandalService]
})
export class MandalModule {}
